export const timezonesUS = [
    { text: "(UTC-12:00) International Date Line West", value: "Dateline Standard Time" },
    { text: "(UTC-11:00) Coordinated Universal Time-11", value: "UTC-11" },
    { text: "(UTC-10:00) Aleutian Islands", value: "Aleutian Standard Time" },
    { text: "(UTC-10:00) Hawaii", value: "Hawaiian Standard Time" },
    { text: "(UTC-09:30) Marquesas Islands", value: "Marquesas Standard Time" },
    { text: "(UTC-09:00) Alaska", value: "Alaskan Standard Time" },
    { text: "(UTC-09:00) Coordinated Universal Time-09", value: "UTC-09" },
    { text: "(UTC-08:00) Baja California", value: "Pacific Standard Time (Mexico)" },
    { text: "(UTC-08:00) Coordinated Universal Time-08", value: "UTC-08" },
    { text: "(UTC-08:00) Pacific Time (US & Canada)", value: "Pacific Standard Time" },
    { text: "(UTC-07:00) Arizona", value: "US Mountain Standard Time" },
    { text: "(UTC-07:00) Chihuahua, La Paz, Mazatlan", value: "Mountain Standard Time (Mexico)" },
    { text: "(UTC-07:00) Mountain Time (US & Canada)", value: "Mountain Standard Time" },
    { text: "(UTC-07:00) Yukon", value: "Yukon Standard Time" },
    { text: "(UTC-06:00) Central America", value: "Central America Standard Time" },
    { text: "(UTC-06:00) Central Time (US & Canada)", value: "Central Standard Time" },
    { text: "(UTC-06:00) Easter Island", value: "Easter Island Standard Time" },
    { text: "(UTC-06:00) Guadalajara, Mexico City, Monterrey", value: "Central Standard Time (Mexico)" },
    { text: "(UTC-06:00) Saskatchewan", value: "Canada Central Standard Time" },
    { text: "(UTC-05:00) Bogota, Lima, Quito, Rio Branco", value: "SA Pacific Standard Time" },
    { text: "(UTC-05:00) Chetumal", value: "Eastern Standard Time (Mexico)" },
    { text: "(UTC-05:00) Eastern Time (US & Canada)", value: "Eastern Standard Time" },
    { text: "(UTC-05:00) Haiti", value: "Haiti Standard Time" },
    { text: "(UTC-05:00) Havana", value: "Cuba Standard Time" },
    { text: "(UTC-05:00) Indiana (East)", value: "US Eastern Standard Time" },
    { text: "(UTC-05:00) Turks and Caicos", value: "Turks And Caicos Standard Time" },
    { text: "(UTC-04:00) Asuncion", value: "Paraguay Standard Time" },
    { text: "(UTC-04:00) Atlantic Time (Canada)", value: "Atlantic Standard Time" },
    { text: "(UTC-04:00) Caracas", value: "Venezuela Standard Time" },
    { text: "(UTC-04:00) Cuiaba", value: "Central Brazilian Standard Time" },
    { text: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan", value: "SA Western Standard Time" },
    { text: "(UTC-04:00) Santiago", value: "Pacific SA Standard Time" },
    { text: "(UTC-03:30) Newfoundland", value: "Newfoundland Standard Time" },
    { text: "(UTC-03:00) Araguaina", value: "Tocantins Standard Time" },
    { text: "(UTC-03:00) Brasilia", value: "E. South America Standard Time" },
    { text: "(UTC-03:00) Cayenne, Fortaleza", value: "SA Eastern Standard Time" },
    { text: "(UTC-03:00) City of Buenos Aires", value: "Argentina Standard Time" },
    { text: "(UTC-03:00) Greenland", value: "Greenland Standard Time" },
    { text: "(UTC-03:00) Montevideo", value: "Montevideo Standard Time" },
    { text: "(UTC-03:00) Punta Arenas", value: "Magallanes Standard Time" },
    { text: "(UTC-03:00) Saint Pierre and Miquelon", value: "Saint Pierre Standard Time" },
    { text: "(UTC-03:00) Salvador", value: "Bahia Standard Time" },
    { text: "(UTC-02:00) Coordinated Universal Time-02", value: "UTC-02" },
    { text: "(UTC-01:00) Azores", value: "Azores Standard Time" },
    { text: "(UTC-01:00) Cabo Verde Is.", value: "Cape Verde Standard Time" },
    { text: "(UTC) Coordinated Universal Time", value: "UTC" },
    { text: "(UTC+00:00) Dublin, Edinburgh, Lisbon, London", value: "GMT Standard Time" },
    { text: "(UTC+00:00) Monrovia, Reykjavik", value: "Greenwich Standard Time" },
    { text: "(UTC+00:00) Sao Tome", value: "Sao Tome Standard Time" },
    { text: "(UTC+01:00) Casablanca", value: "Morocco Standard Time" },
    { text: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna", value: "W. Europe Standard Time" },
    { text: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague", value: "Central Europe Standard Time" },
    { text: "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris", value: "Romance Standard Time" },
    { text: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb", value: "Central European Standard Time" },
    { text: "(UTC+01:00) West Central Africa", value: "W. Central Africa Standard Time" },
    { text: "(UTC+02:00) Athens, Bucharest", value: "GTB Standard Time" },
    { text: "(UTC+02:00) Beirut", value: "Middle East Standard Time" },
    { text: "(UTC+02:00) Cairo", value: "Egypt Standard Time" },
    { text: "(UTC+02:00) Chisinau", value: "E. Europe Standard Time" },
    { text: "(UTC+02:00) Damascus", value: "Syria Standard Time" },
    { text: "(UTC+02:00) Gaza, Hebron", value: "West Bank Standard Time" },
    { text: "(UTC+02:00) Harare, Pretoria", value: "South Africa Standard Time" },
    { text: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius", value: "FLE Standard Time" },
    { text: "(UTC+02:00) Jerusalem", value: "Israel Standard Time" },
    { text: "(UTC+02:00) Juba", value: "South Sudan Standard Time" },
    { text: "(UTC+02:00) Kaliningrad", value: "Kaliningrad Standard Time" },
    { text: "(UTC+02:00) Khartoum", value: "Sudan Standard Time" },
    { text: "(UTC+02:00) Tripoli", value: "Libya Standard Time" },
    { text: "(UTC+02:00) Windhoek", value: "Namibia Standard Time" },
    { text: "(UTC+03:00) Amman", value: "Jordan Standard Time" },
    { text: "(UTC+03:00) Baghdad", value: "Arabic Standard Time" },
    { text: "(UTC+03:00) Istanbul", value: "Turkey Standard Time" },
    { text: "(UTC+03:00) Kuwait, Riyadh", value: "Arab Standard Time" },
    { text: "(UTC+03:00) Minsk", value: "Belarus Standard Time" },
    { text: "(UTC+03:00) Moscow, St. Petersburg", value: "Russian Standard Time" },
    { text: "(UTC+03:00) Nairobi", value: "E. Africa Standard Time" },
    { text: "(UTC+03:00) Volgograd", value: "Volgograd Standard Time" },
    { text: "(UTC+03:30) Tehran", value: "Iran Standard Time" },
    { text: "(UTC+04:00) Abu Dhabi, Muscat", value: "Arabian Standard Time" },
    { text: "(UTC+04:00) Astrakhan, Ulyanovsk", value: "Astrakhan Standard Time" },
    { text: "(UTC+04:00) Baku", value: "Azerbaijan Standard Time" },
    { text: "(UTC+04:00) Izhevsk, Samara", value: "Russia Time Zone 3" },
    { text: "(UTC+04:00) Port Louis", value: "Mauritius Standard Time" },
    { text: "(UTC+04:00) Saratov", value: "Saratov Standard Time" },
    { text: "(UTC+04:00) Tbilisi", value: "Georgian Standard Time" },
    { text: "(UTC+04:00) Yerevan", value: "Caucasus Standard Time" },
    { text: "(UTC+04:30) Kabul", value: "Afghanistan Standard Time" },
    { text: "(UTC+05:00) Ashgabat, Tashkent", value: "West Asia Standard Time" },
    { text: "(UTC+05:00) Ekaterinburg", value: "Ekaterinburg Standard Time" },
    { text: "(UTC+05:00) Islamabad, Karachi", value: "Pakistan Standard Time" },
    { text: "(UTC+05:00) Qyzylorda", value: "Qyzylorda Standard Time" },
    { text: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi", value: "India Standard Time" },
    { text: "(UTC+05:30) Sri Jayawardenepura", value: "Sri Lanka Standard Time" },
    { text: "(UTC+05:45) Kathmandu", value: "Nepal Standard Time" },
    { text: "(UTC+06:00) Astana", value: "Central Asia Standard Time" },
    { text: "(UTC+06:00) Dhaka", value: "Bangladesh Standard Time" },
    { text: "(UTC+06:00) Omsk", value: "Omsk Standard Time" },
    { text: "(UTC+06:30) Yangon (Rangoon)", value: "Myanmar Standard Time" },
    { text: "(UTC+07:00) Bangkok, Hanoi, Jakarta", value: "SE Asia Standard Time" },
    { text: "(UTC+07:00) Barnaul, Gorno-Altaysk", value: "Altai Standard Time" },
    { text: "(UTC+07:00) Hovd", value: "W. Mongolia Standard Time" },
    { text: "(UTC+07:00) Krasnoyarsk", value: "North Asia Standard Time" },
    { text: "(UTC+07:00) Novosibirsk", value: "N. Central Asia Standard Time" },
    { text: "(UTC+07:00) Tomsk", value: "Tomsk Standard Time" },
    { text: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi", value: "China Standard Time" },
    { text: "(UTC+08:00) Irkutsk", value: "North Asia East Standard Time" },
    { text: "(UTC+08:00) Kuala Lumpur, Singapore", value: "Singapore Standard Time" },
    { text: "(UTC+08:00) Perth", value: "W. Australia Standard Time" },
    { text: "(UTC+08:00) Taipei", value: "Taipei Standard Time" },
    { text: "(UTC+08:00) Ulaanbaatar", value: "Ulaanbaatar Standard Time" },
    { text: "(UTC+08:45) Eucla", value: "Aus Central W. Standard Time" },
    { text: "(UTC+09:00) Chita", value: "Transbaikal Standard Time" },
    { text: "(UTC+09:00) Osaka, Sapporo, Tokyo", value: "Tokyo Standard Time" },
    { text: "(UTC+09:00) Pyongyang", value: "North Korea Standard Time" },
    { text: "(UTC+09:00) Seoul", value: "Korea Standard Time" },
    { text: "(UTC+09:00) Yakutsk", value: "Yakutsk Standard Time" },
    { text: "(UTC+09:30) Adelaide", value: "Cen. Australia Standard Time" },
    { text: "(UTC+09:30) Darwin", value: "AUS Central Standard Time" },
    { text: "(UTC+10:00) Brisbane", value: "E. Australia Standard Time" },
    { text: "(UTC+10:00) Canberra, Melbourne, Sydney", value: "AUS Eastern Standard Time" },
    { text: "(UTC+10:00) Guam, Port Moresby", value: "West Pacific Standard Time" },
    { text: "(UTC+10:00) Hobart", value: "Tasmania Standard Time" },
    { text: "(UTC+10:00) Vladivostok", value: "Vladivostok Standard Time" },
    { text: "(UTC+10:30) Lord Howe Island", value: "Lord Howe Standard Time" },
    { text: "(UTC+11:00) Bougainville Island", value: "Bougainville Standard Time" },
    { text: "(UTC+11:00) Chokurdakh", value: "Russia Time Zone 10" },
    { text: "(UTC+11:00) Magadan", value: "Magadan Standard Time" },
    { text: "(UTC+11:00) Norfolk Island", value: "Norfolk Standard Time" },
    { text: "(UTC+11:00) Sakhalin", value: "Sakhalin Standard Time" },
    { text: "(UTC+11:00) Solomon Is., New Caledonia", value: "Central Pacific Standard Time" },
    { text: "(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky", value: "Russia Time Zone 11" },
    { text: "(UTC+12:00) Auckland, Wellington", value: "New Zealand Standard Time" },
    { text: "(UTC+12:00) Coordinated Universal Time+12", value: "UTC+12" },
    { text: "(UTC+12:00) Fiji", value: "Fiji Standard Time" },
    { text: "(UTC+12:45) Chatham Islands", value: "Chatham Islands Standard Time" },
    { text: "(UTC+13:00) Coordinated Universal Time+13", value: "UTC+13" },
    { text: "(UTC+13:00) Nuku'alofa", value: "Tonga Standard Time" },
    { text: "(UTC+13:00) Samoa", value: "Samoa Standard Time" },
    { text: "(UTC+14:00) Kiritimati Island", value: "Line Islands Standard Time" },
];

export const timezonesIT = [
    { text: "(UTC-12:00) Linea cambiamento data internazionale (occidentale)", value: "Dateline Standard Time" },
    { text: "(UTC-11:00) Coordinated Universal Time-11", value: "UTC-11" },
    { text: "(UTC-10:00) Isole Aleutine", value: "Aleutian Standard Time" },
    { text: "(UTC-10:00) Hawaii", value: "Hawaiian Standard Time" },
    { text: "(UTC-09:30) Isole Marquesas", value: "Marquesas Standard Time" },
    { text: "(UTC-09:00) Alaska", value: "Alaskan Standard Time" },
    { text: "(UTC-09:00) Coordinated Universal Time-09", value: "UTC-09" },
    { text: "(UTC-08:00) Baja California", value: "Pacific Standard Time (Mexico)" },
    { text: "(UTC-08:00) Coordinated Universal Time-08", value: "UTC-08" },
    { text: "(UTC-08:00) Fuso costa pacifica (USA e Canada)", value: "Pacific Standard Time" },
    { text: "(UTC-07:00) Arizona", value: "US Mountain Standard Time" },
    { text: "(UTC-07:00) Chihuahua, La Paz, Mazatlan", value: "Mountain Standard Time (Mexico)" },
    { text: "(UTC-07:00) Fuso occidentale (USA e Canada)", value: "Mountain Standard Time" },
    { text: "(UTC-07:00) Yukon", value: "Yukon Standard Time" },
    { text: "(UTC-06:00) America centrale", value: "Central America Standard Time" },
    { text: "(UTC-06:00) Fuso centrale (USA e Canada)", value: "Central Standard Time" },
    { text: "(UTC-06:00) Isola di Pasqua", value: "Easter Island Standard Time" },
    { text: "(UTC-06:00) Guadalajara, Città del Messico, Monterrey", value: "Central Standard Time (Mexico)" },
    { text: "(UTC-06:00) Saskatchewan", value: "Canada Central Standard Time" },
    { text: "(UTC-05:00) Bogotà, Lima, Quito, Rio Branco", value: "SA Pacific Standard Time" },
    { text: "(UTC-05:00) Chetumal", value: "Eastern Standard Time (Mexico)" },
    { text: "(UTC-05:00) Fuso orientale (USA e Canada)", value: "Eastern Standard Time" },
    { text: "(UTC-05:00) Haiti", value: "Haiti Standard Time" },
    { text: "(UTC-05:00) L'Avana", value: "Cuba Standard Time" },
    { text: "(UTC-05:00) Indiana (Est)", value: "US Eastern Standard Time" },
    { text: "(UTC-05:00) Turks e Caicos", value: "Turks And Caicos Standard Time" },
    { text: "(UTC-04:00) Asuncion", value: "Paraguay Standard Time" },
    { text: "(UTC-04:00) Ora costa atlantica (Canada)", value: "Atlantic Standard Time" },
    { text: "(UTC-04:00) Caracas", value: "Venezuela Standard Time" },
    { text: "(UTC-04:00) Cuiaba", value: "Central Brazilian Standard Time" },
    { text: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan", value: "SA Western Standard Time" },
    { text: "(UTC-04:00) Santiago", value: "Pacific SA Standard Time" },
    { text: "(UTC-03:30) Terranova", value: "Newfoundland Standard Time" },
    { text: "(UTC-03:00) Araguaina", value: "Tocantins Standard Time" },
    { text: "(UTC-03:00) Brasilia", value: "E. South America Standard Time" },
    { text: "(UTC-03:00) Cayenne, Fortaleza", value: "SA Eastern Standard Time" },
    { text: "(UTC-03:00) Buenos Aires", value: "Argentina Standard Time" },
    { text: "(UTC-03:00) Groenlandia", value: "Greenland Standard Time" },
    { text: "(UTC-03:00) Montevideo", value: "Montevideo Standard Time" },
    { text: "(UTC-03:00) Punta Arenas", value: "Magallanes Standard Time" },
    { text: "(UTC-03:00) Saint-Pierre e Miquelon", value: "Saint Pierre Standard Time" },
    { text: "(UTC-03:00) Salvador", value: "Bahia Standard Time" },
    { text: "(UTC-02:00) Coordinated Universal Time-02", value: "UTC-02" },
    { text: "(UTC-01:00) Azzorre", value: "Azores Standard Time" },
    { text: "(UTC-01:00) Cabo Verde", value: "Cape Verde Standard Time" },
    { text: "(UTC) Coordinated Universal Time", value: "UTC" },
    { text: "(UTC+00:00) Dublino, Edimburgo, Lisbona, Londra", value: "GMT Standard Time" },
    { text: "(UTC+00:00) Monrovia, Reykjavik", value: "Greenwich Standard Time" },
    { text: "(UTC+00:00) Sao Tome", value: "Sao Tome Standard Time" },
    { text: "(UTC+01:00) Casablanca", value: "Morocco Standard Time" },
    { text: "(UTC+01:00) Amsterdam, Berlino, Berna, Roma, Stoccolma, Vienna", value: "W. Europe Standard Time" },
    { text: "(UTC+01:00) Belgrado, Bratislava, Budapest, Lubiana, Praga", value: "Central Europe Standard Time" },
    { text: "(UTC+01:00) Bruxelles, Copenaghen, Madrid, Parigi", value: "Romance Standard Time" },
    { text: "(UTC+01:00) Sarajevo, Skopje, Varsavia, Zagabria", value: "Central European Standard Time" },
    { text: "(UTC+01:00) Repubblica centrafricana occidentale", value: "W. Central Africa Standard Time" },
    { text: "(UTC+02:00) Atene, Bucarest", value: "GTB Standard Time" },
    { text: "(UTC+02:00) Beirut", value: "Middle East Standard Time" },
    { text: "(UTC+02:00) Cairo", value: "Egypt Standard Time" },
    { text: "(UTC+02:00) Chisinau", value: "E. Europe Standard Time" },
    { text: "(UTC+02:00) Damasco", value: "Syria Standard Time" },
    { text: "(UTC+02:00) Gaza, Hebron", value: "West Bank Standard Time" },
    { text: "(UTC+02:00) Harare, Pretoria", value: "South Africa Standard Time" },
    { text: "(UTC+02:00) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius", value: "FLE Standard Time" },
    { text: "(UTC+02:00) Gerusalemme", value: "Israel Standard Time" },
    { text: "(UTC+02:00) Juba", value: "South Sudan Standard Time" },
    { text: "(UTC+02:00) Kaliningrad", value: "Kaliningrad Standard Time" },
    { text: "(UTC+02:00) Khartoum", value: "Sudan Standard Time" },
    { text: "(UTC+02:00) Tripoli", value: "Libya Standard Time" },
    { text: "(UTC+02:00) Windhoek", value: "Namibia Standard Time" },
    { text: "(UTC+03:00) Amman", value: "Jordan Standard Time" },
    { text: "(UTC+03:00) Baghdad", value: "Arabic Standard Time" },
    { text: "(UTC+03:00) Istanbul", value: "Turkey Standard Time" },
    { text: "(UTC+03:00) Kuwait, Riyad", value: "Arab Standard Time" },
    { text: "(UTC+03:00) Minsk", value: "Belarus Standard Time" },
    { text: "(UTC+03:00) Mosca, S. Pietroburgo", value: "Russian Standard Time" },
    { text: "(UTC+03:00) Nairobi", value: "E. Africa Standard Time" },
    { text: "(UTC+03:00) Volgograd", value: "Volgograd Standard Time" },
    { text: "(UTC+03:30) Teheran", value: "Iran Standard Time" },
    { text: "(UTC+04:00) Abu Dhabi, Muscat", value: "Arabian Standard Time" },
    { text: "(UTC+04:00) Astrakhan, Ulyanovsk", value: "Astrakhan Standard Time" },
    { text: "(UTC+04:00) Baku", value: "Azerbaijan Standard Time" },
    { text: "(UTC+04:00) Izhevsk, Samara", value: "Russia Time Zone 3" },
    { text: "(UTC+04:00) Port Louis", value: "Mauritius Standard Time" },
    { text: "(UTC+04:00) Saratov", value: "Saratov Standard Time" },
    { text: "(UTC+04:00) Tbilisi", value: "Georgian Standard Time" },
    { text: "(UTC+04:00) Yerevan", value: "Caucasus Standard Time" },
    { text: "(UTC+04:30) Kabul", value: "Afghanistan Standard Time" },
    { text: "(UTC+05:00) Ashkhabat, Tashkent", value: "West Asia Standard Time" },
    { text: "(UTC+05:00) Ekaterinburg", value: "Ekaterinburg Standard Time" },
    { text: "(UTC+05:00) Islamabad, Karachi", value: "Pakistan Standard Time" },
    { text: "(UTC+05:00) Qyzylorda", value: "Qyzylorda Standard Time" },
    { text: "(UTC+05:30) Chennai, Kolkata (Calcutta), Mumbai, Nuova Delhi", value: "India Standard Time" },
    { text: "(UTC+05:30) Sri Jayawardenepura", value: "Sri Lanka Standard Time" },
    { text: "(UTC+05:45) Kathmandu", value: "Nepal Standard Time" },
    { text: "(UTC+06:00) Astana", value: "Central Asia Standard Time" },
    { text: "(UTC+06:00) Dhaka", value: "Bangladesh Standard Time" },
    { text: "(UTC+06:00) Omsk", value: "Omsk Standard Time" },
    { text: "(UTC+06:30) Yangon (Rangoon)", value: "Myanmar Standard Time" },
    { text: "(UTC+07:00) Bangkok, Hanoi, Giacarta", value: "SE Asia Standard Time" },
    { text: "(UTC+07:00) Barnaul, Gorno-Altaysk", value: "Altai Standard Time" },
    { text: "(UTC+07:00) Hovd", value: "W. Mongolia Standard Time" },
    { text: "(UTC+07:00) Krasnoyarsk", value: "North Asia Standard Time" },
    { text: "(UTC+07:00) Novosibirsk", value: "N. Central Asia Standard Time" },
    { text: "(UTC+07:00) Tomsk", value: "Tomsk Standard Time" },
    { text: "(UTC+08:00) Pechino, Chongqing, Hong Kong, Urumqi", value: "China Standard Time" },
    { text: "(UTC+08:00) Irkutsk", value: "North Asia East Standard Time" },
    { text: "(UTC+08:00) Kuala Lumpur, Singapore", value: "Singapore Standard Time" },
    { text: "(UTC+08:00) Perth", value: "W. Australia Standard Time" },
    { text: "(UTC+08:00) Taipei", value: "Taipei Standard Time" },
    { text: "(UTC+08:00) Ulaanbaatar", value: "Ulaanbaatar Standard Time" },
    { text: "(UTC+08:45) Eucla", value: "Aus Central W. Standard Time" },
    { text: "(UTC+09:00) Chita", value: "Transbaikal Standard Time" },
    { text: "(UTC+09:00) Osaka, Sapporo, Tokyo", value: "Tokyo Standard Time" },
    { text: "(UTC+09:00) Pyongyang", value: "North Korea Standard Time" },
    { text: "(UTC+09:00) Seoul", value: "Korea Standard Time" },
    { text: "(UTC+09:00) Yakutsk", value: "Yakutsk Standard Time" },
    { text: "(UTC+09:30) Adelaide", value: "Cen. Australia Standard Time" },
    { text: "(UTC+09:30) Darwin", value: "AUS Central Standard Time" },
    { text: "(UTC+10:00) Brisbane", value: "E. Australia Standard Time" },
    { text: "(UTC+10:00) Canberra, Melbourne, Sydney", value: "AUS Eastern Standard Time" },
    { text: "(UTC+10:00) Guam, Port Moresby", value: "West Pacific Standard Time" },
    { text: "(UTC+10:00) Hobart", value: "Tasmania Standard Time" },
    { text: "(UTC+10:00) Vladivostok", value: "Vladivostok Standard Time" },
    { text: "(UTC+10:30) Isola di Lord Howe", value: "Lord Howe Standard Time" },
    { text: "(UTC+11:00) Bougainville", value: "Bougainville Standard Time" },
    { text: "(UTC+11:00) Chokurdakh", value: "Russia Time Zone 10" },
    { text: "(UTC+11:00) Magadan", value: "Magadan Standard Time" },
    { text: "(UTC+11:00) Norfolk", value: "Norfolk Standard Time" },
    { text: "(UTC+11:00) Sakhalin", value: "Sakhalin Standard Time" },
    { text: "(UTC+11:00) Is. Salomone, Nuova Caledonia", value: "Central Pacific Standard Time" },
    { text: "(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky", value: "Russia Time Zone 11" },
    { text: "(UTC+12:00) Auckland, Wellington", value: "New Zealand Standard Time" },
    { text: "(UTC+12:00) Coordinated Universal Time+12", value: "UTC+12" },
    { text: "(UTC+12:00) Fiji", value: "Fiji Standard Time" },
    { text: "(UTC+12:45) Isole Chatham", value: "Chatham Islands Standard Time" },
    { text: "(UTC+13:00) Coordinated Universal Time+13", value: "UTC+13" },
    { text: "(UTC+13:00) Nukualofa", value: "Tonga Standard Time" },
    { text: "(UTC+13:00) Samoa", value: "Samoa Standard Time" },
    { text: "(UTC+14:00) Isola Kiritimati", value: "Line Islands Standard Time" },
];

export const timezonesDE = [
    { text: "(UTC-12:00) Internationale Datumsgrenze (Westen)", value: "Dateline Standard Time" },
    { text: "(UTC-11:00) Koordinierte Weltzeit-11", value: "UTC-11" },
    { text: "(UTC-10:00) Aleuten-Inseln", value: "Aleutian Standard Time" },
    { text: "(UTC-10:00) Hawaii", value: "Hawaiian Standard Time" },
    { text: "(UTC-09:30) Marquesas-Inseln", value: "Marquesas Standard Time" },
    { text: "(UTC-09:00) Alaska", value: "Alaskan Standard Time" },
    { text: "(UTC-09:00) Koordinierte Weltzeit-09", value: "UTC-09" },
    { text: "(UTC-08:00) Niederkalifornien", value: "Pacific Standard Time (Mexico)" },
    { text: "(UTC-08:00) Koordinierte Weltzeit-08", value: "UTC-08" },
    { text: "(UTC-08:00) Pacific Zeit (USA & Kanada)", value: "Pacific Standard Time" },
    { text: "(UTC-07:00) Arizona", value: "US Mountain Standard Time" },
    { text: "(UTC-07:00) Chihuahua, La Paz, Mazatlan", value: "Mountain Standard Time (Mexico)" },
    { text: "(UTC-07:00) Mountain Zeit (USA & Kanada)", value: "Mountain Standard Time" },
    { text: "(UTC-07:00) Yukon", value: "Yukon Standard Time" },
    { text: "(UTC-06:00) Mittelamerika", value: "Central America Standard Time" },
    { text: "(UTC-06:00) Central Zeit (USA & Kanada)", value: "Central Standard Time" },
    { text: "(UTC-06:00) Osterinsel", value: "Easter Island Standard Time" },
    { text: "(UTC-06:00) Guadalajara, Mexiko-Stadt, Monterrey", value: "Central Standard Time (Mexico)" },
    { text: "(UTC-06:00) Saskatchewan", value: "Canada Central Standard Time" },
    { text: "(UTC-05:00) Bogotá, Lima, Quito, Rio Branco", value: "SA Pacific Standard Time" },
    { text: "(UTC-05:00) Chetumal", value: "Eastern Standard Time (Mexico)" },
    { text: "(UTC-05:00) Eastern Zeit (USA & Kanada)", value: "Eastern Standard Time" },
    { text: "(UTC-05:00) Haiti", value: "Haiti Standard Time" },
    { text: "(UTC-05:00) Havanna", value: "Cuba Standard Time" },
    { text: "(UTC-05:00) Indiana (Ost)", value: "US Eastern Standard Time" },
    { text: "(UTC-05:00) Turks- und Caicosinseln", value: "Turks And Caicos Standard Time" },
    { text: "(UTC-04:00) Asuncion", value: "Paraguay Standard Time" },
    { text: "(UTC-04:00) Atlantic (Kanada)", value: "Atlantic Standard Time" },
    { text: "(UTC-04:00) Caracas", value: "Venezuela Standard Time" },
    { text: "(UTC-04:00) Cuiaba", value: "Central Brazilian Standard Time" },
    { text: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan", value: "SA Western Standard Time" },
    { text: "(UTC-04:00) Santiago", value: "Pacific SA Standard Time" },
    { text: "(UTC-03:30) Neufundland", value: "Newfoundland Standard Time" },
    { text: "(UTC-03:00) Araguaína", value: "Tocantins Standard Time" },
    { text: "(UTC-03:00) Brasilia", value: "E. South America Standard Time" },
    { text: "(UTC-03:00) Cayenne, Fortaleza", value: "SA Eastern Standard Time" },
    { text: "(UTC-03:00) Buenos Aires", value: "Argentina Standard Time" },
    { text: "(UTC-03:00) Grönland", value: "Greenland Standard Time" },
    { text: "(UTC-03:00) Montevideo", value: "Montevideo Standard Time" },
    { text: "(UTC-03:00) Punta Arenas", value: "Magallanes Standard Time" },
    { text: "(UTC-03:00) St. Pierre und Miquelon", value: "Saint Pierre Standard Time" },
    { text: "(UTC-03:00) Salvador", value: "Bahia Standard Time" },
    { text: "(UTC-02:00) Koordinierte Weltzeit-02", value: "UTC-02" },
    { text: "(UTC-01:00) Azoren", value: "Azores Standard Time" },
    { text: "(UTC-01:00) Cabo Verde", value: "Cape Verde Standard Time" },
    { text: "(UTC) Koordinierte Weltzeit", value: "UTC" },
    { text: "(UTC+00:00) Dublin, Edinburgh, Lissabon, London", value: "GMT Standard Time" },
    { text: "(UTC+00:00) Monrovia, Reykjavik", value: "Greenwich Standard Time" },
    { text: "(UTC+00:00) São Tomé", value: "Sao Tome Standard Time" },
    { text: "(UTC+01:00) Casablanca", value: "Morocco Standard Time" },
    { text: "(UTC+01:00) Amsterdam, Berlin, Bern, Rom, Stockholm, Wien", value: "W. Europe Standard Time" },
    { text: "(UTC+01:00) Belgrad, Bratislava (Pressburg), Budapest, Ljubljana, Prag", value: "Central Europe Standard Time" },
    { text: "(UTC+01:00) Brüssel, Kopenhagen, Madrid, Paris", value: "Romance Standard Time" },
    { text: "(UTC+01:00) Sarajevo, Skopje, Warschau, Zagreb", value: "Central European Standard Time" },
    { text: "(UTC+01:00) West-Zentralafrika", value: "W. Central Africa Standard Time" },
    { text: "(UTC+02:00) Athen, Bukarest", value: "GTB Standard Time" },
    { text: "(UTC+02:00) Beirut", value: "Middle East Standard Time" },
    { text: "(UTC+02:00) Kairo", value: "Egypt Standard Time" },
    { text: "(UTC+02:00) Chisinau", value: "E. Europe Standard Time" },
    { text: "(UTC+02:00) Damaskus", value: "Syria Standard Time" },
    { text: "(UTC+02:00) Gaza, Hebron", value: "West Bank Standard Time" },
    { text: "(UTC+02:00) Harare, Pretoria", value: "South Africa Standard Time" },
    { text: "(UTC+02:00) Helsinki, Kiew, Riga, Sofia, Tallinn, Wilna", value: "FLE Standard Time" },
    { text: "(UTC+02:00) Jerusalem", value: "Israel Standard Time" },
    { text: "(UTC+02:00) Juba", value: "South Sudan Standard Time" },
    { text: "(UTC+02:00) Kaliningrad", value: "Kaliningrad Standard Time" },
    { text: "(UTC+02:00) Khartum", value: "Sudan Standard Time" },
    { text: "(UTC+02:00) Tripolis", value: "Libya Standard Time" },
    { text: "(UTC+02:00) Windhuk", value: "Namibia Standard Time" },
    { text: "(UTC+03:00) Amman", value: "Jordan Standard Time" },
    { text: "(UTC+03:00) Bagdad", value: "Arabic Standard Time" },
    { text: "(UTC+03:00) Istanbul", value: "Turkey Standard Time" },
    { text: "(UTC+03:00) Kuwait, Riad", value: "Arab Standard Time" },
    { text: "(UTC+03:00) Minsk", value: "Belarus Standard Time" },
    { text: "(UTC+03:00) Moskau, St. Petersburg", value: "Russian Standard Time" },
    { text: "(UTC+03:00) Nairobi", value: "E. Africa Standard Time" },
    { text: "(UTC+03:00) Wolgograd", value: "Volgograd Standard Time" },
    { text: "(UTC+03:30) Teheran", value: "Iran Standard Time" },
    { text: "(UTC+04:00) Abu Dhabi, Muskat", value: "Arabian Standard Time" },
    { text: "(UTC+04:00) Astrachan, Uljanowsk", value: "Astrakhan Standard Time" },
    { text: "(UTC+04:00) Baku", value: "Azerbaijan Standard Time" },
    { text: "(UTC+04:00) Ischewsk, Samara", value: "Russia Time Zone 3" },
    { text: "(UTC+04:00) Port Louis", value: "Mauritius Standard Time" },
    { text: "(UTC+04:00) Saratov", value: "Saratov Standard Time" },
    { text: "(UTC+04:00) Tiflis", value: "Georgian Standard Time" },
    { text: "(UTC+04:00) Eriwan", value: "Caucasus Standard Time" },
    { text: "(UTC+04:30) Kabul", value: "Afghanistan Standard Time" },
    { text: "(UTC+05:00) Aschgabat, Taschkent", value: "West Asia Standard Time" },
    { text: "(UTC+05:00) Jekaterinburg", value: "Ekaterinburg Standard Time" },
    { text: "(UTC+05:00) Islamabad, Karatschi", value: "Pakistan Standard Time" },
    { text: "(UTC+05:00) Qysylorda", value: "Qyzylorda Standard Time" },
    { text: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi", value: "India Standard Time" },
    { text: "(UTC+05:30) Sri Jayawardenepura", value: "Sri Lanka Standard Time" },
    { text: "(UTC+05:45) Katmandu", value: "Nepal Standard Time" },
    { text: "(UTC+06:00) Astana", value: "Central Asia Standard Time" },
    { text: "(UTC+06:00) Dakka", value: "Bangladesh Standard Time" },
    { text: "(UTC+06:00) Omsk", value: "Omsk Standard Time" },
    { text: "(UTC+06:30) Yangon (Rangun)", value: "Myanmar Standard Time" },
    { text: "(UTC+07:00) Bangkok, Hanoi, Jakarta", value: "SE Asia Standard Time" },
    { text: "(UTC+07:00) Barnaul, Gorno-Altaisk", value: "Altai Standard Time" },
    { text: "(UTC+07:00) Hovd", value: "W. Mongolia Standard Time" },
    { text: "(UTC+07:00) Krasnojarsk", value: "North Asia Standard Time" },
    { text: "(UTC+07:00) Nowosibirsk", value: "N. Central Asia Standard Time" },
    { text: "(UTC+07:00) Tomsk", value: "Tomsk Standard Time" },
    { text: "(UTC+08:00) Peking, Chongqing, Hongkong (SAR), Urumchi", value: "China Standard Time" },
    { text: "(UTC+08:00) Irkutsk", value: "North Asia East Standard Time" },
    { text: "(UTC+08:00) Kuala Lumpur, Singapur", value: "Singapore Standard Time" },
    { text: "(UTC+08:00) Perth", value: "W. Australia Standard Time" },
    { text: "(UTC+08:00) Taipeh", value: "Taipei Standard Time" },
    { text: "(UTC+08:00) Ulan-Bator", value: "Ulaanbaatar Standard Time" },
    { text: "(UTC+08:45) Eucla", value: "Aus Central W. Standard Time" },
    { text: "(UTC+09:00) Chita", value: "Transbaikal Standard Time" },
    { text: "(UTC+09:00) Osaka, Sapporo, Tokio", value: "Tokyo Standard Time" },
    { text: "(UTC+09:00) Pjöngjang", value: "North Korea Standard Time" },
    { text: "(UTC+09:00) Seoul", value: "Korea Standard Time" },
    { text: "(UTC+09:00) Jakutsk", value: "Yakutsk Standard Time" },
    { text: "(UTC+09:30) Adelaide", value: "Cen. Australia Standard Time" },
    { text: "(UTC+09:30) Darwin", value: "AUS Central Standard Time" },
    { text: "(UTC+10:00) Brisbane", value: "E. Australia Standard Time" },
    { text: "(UTC+10:00) Canberra, Melbourne, Sydney", value: "AUS Eastern Standard Time" },
    { text: "(UTC+10:00) Guam, Port Moresby", value: "West Pacific Standard Time" },
    { text: "(UTC+10:00) Hobart", value: "Tasmania Standard Time" },
    { text: "(UTC+10:00) Wladiwostok", value: "Vladivostok Standard Time" },
    { text: "(UTC+10:30) Lord-Howe-Insel", value: "Lord Howe Standard Time" },
    { text: "(UTC+11:00) Bougainville-Insel", value: "Bougainville Standard Time" },
    { text: "(UTC+11:00) Tschokurdach", value: "Russia Time Zone 10" },
    { text: "(UTC+11:00) Magadan", value: "Magadan Standard Time" },
    { text: "(UTC+11:00) Norfolkinsel", value: "Norfolk Standard Time" },
    { text: "(UTC+11:00) Sachalin", value: "Sakhalin Standard Time" },
    { text: "(UTC+11:00) Salomonen, Neu-Kaledonien", value: "Central Pacific Standard Time" },
    { text: "(UTC+12:00) Anadyr, Petropawlowsk-Kamtschatski", value: "Russia Time Zone 11" },
    { text: "(UTC+12:00) Auckland, Wellington", value: "New Zealand Standard Time" },
    { text: "(UTC+12:00) Koordinierte Weltzeit+12", value: "UTC+12" },
    { text: "(UTC+12:00) Fidschi", value: "Fiji Standard Time" },
    { text: "(UTC+12:45) Chatham-Inseln", value: "Chatham Islands Standard Time" },
    { text: "(UTC+13:00) Koordinierte Weltzeit+13", value: "UTC+13" },
    { text: "(UTC+13:00) Nuku'alofa", value: "Tonga Standard Time" },
    { text: "(UTC+13:00) Samoa", value: "Samoa Standard Time" },
    { text: "(UTC+14:00) Insel Kiritimati", value: "Line Islands Standard Time" },
];

export const timezonesES = [
    { text: "(UTC-12:00) Línea internacional de cambio de fecha", value: "Dateline Standard Time" },
    { text: "(UTC-11:00) Hora universal coordinada-11", value: "UTC-11" },
    { text: "(UTC-10:00) Islas Aleutianas", value: "Aleutian Standard Time" },
    { text: "(UTC-10:00) Hawai", value: "Hawaiian Standard Time" },
    { text: "(UTC-09:30) Islas Marquesas", value: "Marquesas Standard Time" },
    { text: "(UTC-09:00) Alaska", value: "Alaskan Standard Time" },
    { text: "(UTC-09:00) Hora universal coordinada-09", value: "UTC-09" },
    { text: "(UTC-08:00) Baja California", value: "Pacific Standard Time (Mexico)" },
    { text: "(UTC-08:00) Hora universal coordinada-08", value: "UTC-08" },
    { text: "(UTC-08:00) Hora del Pacífico (EE.UU. y Canadá)", value: "Pacific Standard Time" },
    { text: "(UTC-07:00) Arizona", value: "US Mountain Standard Time" },
    { text: "(UTC-07:00) Chihuahua, La Paz, Mazatlán", value: "Mountain Standard Time (Mexico)" },
    { text: "(UTC-07:00) Hora de las Montañas Rocosas (EE.UU. y Canadá)", value: "Mountain Standard Time" },
    { text: "(UTC-07:00) Yukon", value: "Yukon Standard Time" },
    { text: "(UTC-06:00) América Central", value: "Central America Standard Time" },
    { text: "(UTC-06:00) Hora central (EE.UU. y Canadá)", value: "Central Standard Time" },
    { text: "(UTC-06:00) Isla de Pascua", value: "Easter Island Standard Time" },
    { text: "(UTC-06:00) Guadalajara, Ciudad de México, Monterrey", value: "Central Standard Time (Mexico)" },
    { text: "(UTC-06:00) Saskatchewan", value: "Canada Central Standard Time" },
    { text: "(UTC-05:00) Bogotá, Lima, Quito, Rio Branco", value: "SA Pacific Standard Time" },
    { text: "(UTC-05:00) Chetumal", value: "Eastern Standard Time (Mexico)" },
    { text: "(UTC-05:00) Hora del este (EE.UU. y Canadá)", value: "Eastern Standard Time" },
    { text: "(UTC-05:00) Haití", value: "Haiti Standard Time" },
    { text: "(UTC-05:00) La Habana", value: "Cuba Standard Time" },
    { text: "(UTC-05:00) Indiana (este)", value: "US Eastern Standard Time" },
    { text: "(UTC-05:00) Islas Turcas y Caicos", value: "Turks And Caicos Standard Time" },
    { text: "(UTC-04:00) Asunción", value: "Paraguay Standard Time" },
    { text: "(UTC-04:00) Hora del Atlántico (Canadá)", value: "Atlantic Standard Time" },
    { text: "(UTC-04:00) Caracas", value: "Venezuela Standard Time" },
    { text: "(UTC-04:00) Cuiabá", value: "Central Brazilian Standard Time" },
    { text: "(UTC-04:00) Georgetown, La Paz, Manaos, San Juan", value: "SA Western Standard Time" },
    { text: "(UTC-04:00) Santiago", value: "Pacific SA Standard Time" },
    { text: "(UTC-03:30) Terranova", value: "Newfoundland Standard Time" },
    { text: "(UTC-03:00) Araguaína", value: "Tocantins Standard Time" },
    { text: "(UTC-03:00) Brasilia", value: "E. South America Standard Time" },
    { text: "(UTC-03:00) Cayena, Fortaleza", value: "SA Eastern Standard Time" },
    { text: "(UTC-03:00) Ciudad de Buenos Aires", value: "Argentina Standard Time" },
    { text: "(UTC-03:00) Groenlandia", value: "Greenland Standard Time" },
    { text: "(UTC-03:00) Montevideo", value: "Montevideo Standard Time" },
    { text: "(UTC-03:00) Punta Arenas", value: "Magallanes Standard Time" },
    { text: "(UTC-03:00) San Pedro y Miquelón", value: "Saint Pierre Standard Time" },
    { text: "(UTC-03:00) Salvador", value: "Bahia Standard Time" },
    { text: "(UTC-02:00) Hora universal coordinada-02", value: "UTC-02" },
    { text: "(UTC-01:00) Azores", value: "Azores Standard Time" },
    { text: "(UTC-01:00) Cabo Verde", value: "Cape Verde Standard Time" },
    { text: "(UTC) Hora universal coordinada", value: "UTC" },
    { text: "(UTC+00:00) Dublín, Edimburgo, Lisboa, Londres", value: "GMT Standard Time" },
    { text: "(UTC+00:00) Monrovia, Reikiavik", value: "Greenwich Standard Time" },
    { text: "(UTC+00:00) Santo Tomé", value: "Sao Tome Standard Time" },
    { text: "(UTC+01:00) Casablanca", value: "Morocco Standard Time" },
    { text: "(UTC+01:00) Amsterdam, Berlín, Berna, Roma, Estocolmo, Viena", value: "W. Europe Standard Time" },
    { text: "(UTC+01:00) Belgrado, Bratislava, Budapest, Liubliana, Praga", value: "Central Europe Standard Time" },
    { text: "(UTC+01:00) Bruselas, Copenhague, Madrid, París", value: "Romance Standard Time" },
    { text: "(UTC+01:00) Sarajevo, Skopie, Varsovia, Zagreb", value: "Central European Standard Time" },
    { text: "(UTC+01:00) África Central Occidental", value: "W. Central Africa Standard Time" },
    { text: "(UTC+02:00) Atenas, Bucarest", value: "GTB Standard Time" },
    { text: "(UTC+02:00) Beirut", value: "Middle East Standard Time" },
    { text: "(UTC+02:00) El Cairo", value: "Egypt Standard Time" },
    { text: "(UTC+02:00) Chisinau", value: "E. Europe Standard Time" },
    { text: "(UTC+02:00) Damasco", value: "Syria Standard Time" },
    { text: "(UTC+02:00) Gaza, Hebrón", value: "West Bank Standard Time" },
    { text: "(UTC+02:00) Harare, Pretoria", value: "South Africa Standard Time" },
    { text: "(UTC+02:00) Helsinki, Kiev, Riga, Sofía, Tallin, Vilna", value: "FLE Standard Time" },
    { text: "(UTC+02:00) Jerusalén", value: "Israel Standard Time" },
    { text: "(UTC+02:00) Yuba", value: "South Sudan Standard Time" },
    { text: "(UTC+02:00) Kaliningrado", value: "Kaliningrad Standard Time" },
    { text: "(UTC+02:00) Jartum", value: "Sudan Standard Time" },
    { text: "(UTC+02:00) Trípoli", value: "Libya Standard Time" },
    { text: "(UTC+02:00) Windhoek", value: "Namibia Standard Time" },
    { text: "(UTC+03:00) Ammán", value: "Jordan Standard Time" },
    { text: "(UTC+03:00) Bagdad", value: "Arabic Standard Time" },
    { text: "(UTC+03:00) Estambul", value: "Turkey Standard Time" },
    { text: "(UTC+03:00) Kuwait, Riad", value: "Arab Standard Time" },
    { text: "(UTC+03:00) Minsk", value: "Belarus Standard Time" },
    { text: "(UTC+03:00) Moscú, San Petersburgo", value: "Russian Standard Time" },
    { text: "(UTC+03:00) Nairobi", value: "E. Africa Standard Time" },
    { text: "(UTC+03:00) Volgogrado", value: "Volgograd Standard Time" },
    { text: "(UTC+03:30) Teherán", value: "Iran Standard Time" },
    { text: "(UTC+04:00) Abu Dabi, Mascate", value: "Arabian Standard Time" },
    { text: "(UTC+04:00) Astrakhan, Ulyanovsk", value: "Astrakhan Standard Time" },
    { text: "(UTC+04:00) Bakú", value: "Azerbaijan Standard Time" },
    { text: "(UTC+04:00) Izhevsk, Samara", value: "Russia Time Zone 3" },
    { text: "(UTC+04:00) Port Louis", value: "Mauritius Standard Time" },
    { text: "(UTC+04:00) Sarátov", value: "Saratov Standard Time" },
    { text: "(UTC+04:00) Tiflis", value: "Georgian Standard Time" },
    { text: "(UTC+04:00) Ereván", value: "Caucasus Standard Time" },
    { text: "(UTC+04:30) Kabul", value: "Afghanistan Standard Time" },
    { text: "(UTC+05:00) Asjabad, Tashkent", value: "West Asia Standard Time" },
    { text: "(UTC+05:00) Ekaterimburgo", value: "Ekaterinburg Standard Time" },
    { text: "(UTC+05:00) Islamabad, Karachi", value: "Pakistan Standard Time" },
    { text: "(UTC+05:00) Qyzylorda", value: "Qyzylorda Standard Time" },
    { text: "(UTC+05:30) Chennai, Kolkata (Calcuta), Mumbai, Nueva Delhi", value: "India Standard Time" },
    { text: "(UTC+05:30) Sri Jayawardenepura", value: "Sri Lanka Standard Time" },
    { text: "(UTC+05:45) Katmandú", value: "Nepal Standard Time" },
    { text: "(UTC+06:00) Astaná", value: "Central Asia Standard Time" },
    { text: "(UTC+06:00) Dacca", value: "Bangladesh Standard Time" },
    { text: "(UTC+06:00) Omsk", value: "Omsk Standard Time" },
    { text: "(UTC+06:30) Yangón (Rangún)", value: "Myanmar Standard Time" },
    { text: "(UTC+07:00) Bangkok, Hanói, Yakarta", value: "SE Asia Standard Time" },
    { text: "(UTC+07:00) Barnaul, Gorno-Altaysk", value: "Altai Standard Time" },
    { text: "(UTC+07:00) Hovd", value: "W. Mongolia Standard Time" },
    { text: "(UTC+07:00) Krasnoyarsk", value: "North Asia Standard Time" },
    { text: "(UTC+07:00) Novosibirsk", value: "N. Central Asia Standard Time" },
    { text: "(UTC+07:00) Tomsk", value: "Tomsk Standard Time" },
    { text: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi", value: "China Standard Time" },
    { text: "(UTC+08:00) Irkutsk", value: "North Asia East Standard Time" },
    { text: "(UTC+08:00) Kuala Lumpur, Singapur", value: "Singapore Standard Time" },
    { text: "(UTC+08:00) Perth", value: "W. Australia Standard Time" },
    { text: "(UTC+08:00) Taipéi", value: "Taipei Standard Time" },
    { text: "(UTC+08:00) Ulán Bator", value: "Ulaanbaatar Standard Time" },
    { text: "(UTC+08:45) Eucla", value: "Aus Central W. Standard Time" },
    { text: "(UTC+09:00) Chita", value: "Transbaikal Standard Time" },
    { text: "(UTC+09:00) Osaka, Sapporo, Tokio", value: "Tokyo Standard Time" },
    { text: "(UTC+09:00) Pyongyang", value: "North Korea Standard Time" },
    { text: "(UTC+09:00) Seúl", value: "Korea Standard Time" },
    { text: "(UTC+09:00) Yakutsk", value: "Yakutsk Standard Time" },
    { text: "(UTC+09:30) Adelaida", value: "Cen. Australia Standard Time" },
    { text: "(UTC+09:30) Darwin", value: "AUS Central Standard Time" },
    { text: "(UTC+10:00) Brisbane", value: "E. Australia Standard Time" },
    { text: "(UTC+10:00) Canberra, Melbourne, Sídney", value: "AUS Eastern Standard Time" },
    { text: "(UTC+10:00) Guam, Port Moresby", value: "West Pacific Standard Time" },
    { text: "(UTC+10:00) Hobart", value: "Tasmania Standard Time" },
    { text: "(UTC+10:00) Vladivostok", value: "Vladivostok Standard Time" },
    { text: "(UTC+10:30) Isla Lord Howe", value: "Lord Howe Standard Time" },
    { text: "(UTC+11:00) Isla Bougainville", value: "Bougainville Standard Time" },
    { text: "(UTC+11:00) Chokurdakh", value: "Russia Time Zone 10" },
    { text: "(UTC+11:00) Magadán", value: "Magadan Standard Time" },
    { text: "(UTC+11:00) Isla Norfolk", value: "Norfolk Standard Time" },
    { text: "(UTC+11:00) Sajalín", value: "Sakhalin Standard Time" },
    { text: "(UTC+11:00) Islas Salomón, Nueva Caledonia", value: "Central Pacific Standard Time" },
    { text: "(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky", value: "Russia Time Zone 11" },
    { text: "(UTC+12:00) Auckland, Wellington", value: "New Zealand Standard Time" },
    { text: "(UTC+12:00) Hora universal coordinada+12", value: "UTC+12" },
    { text: "(UTC+12:00) Fiyi", value: "Fiji Standard Time" },
    { text: "(UTC+12:45) Islas Chatham", value: "Chatham Islands Standard Time" },
    { text: "(UTC+13:00) Hora universal coordinada+13", value: "UTC+13" },
    { text: "(UTC+13:00) Nuku'alofa", value: "Tonga Standard Time" },
    { text: "(UTC+13:00) Samoa", value: "Samoa Standard Time" },
    { text: "(UTC+14:00) Isla Kiritimati", value: "Line Islands Standard Time" },
];
